import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import translate from "src/i18n/translate";
import { ReportingYears } from "./ReportingYears";
import UnauthorizedComponent from "src/features/insights/UnauthorizedComponent";
import { usePageTitle } from 'src/hooks/usePageTitle';
export function InsightsSettings(_a) {
    var auth = _a.auth;
    usePageTitle('Settings');
    return (_jsx(_Fragment, { children: auth ? (_jsxs("div", { className: "home-page-header", children: [_jsx("div", { className: "home-title-container home-settings", children: _jsxs("div", { children: [_jsx("div", { className: "home-title", children: translate("app.home.settings") }), _jsx("div", { className: "settings-title-description", children: translate("app.settings.desc") })] }) }), _jsx(ReportingYears, {})] })) : (_jsx(UnauthorizedComponent, {})) }));
}
